import { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { api } from '../api';

/* =====================================================================
   El cartel del aviso vigente · CUMPLIMIENTO F5 («primer inicio con
   aviso», que CORREO F2 dejó en esta cola)
   =====================================================================
   Si el dueño de TEGO declaró una versión vigente y esta persona todavía
   no la aceptó, se dice arriba de cualquier pantalla y se lleva a
   «Mis datos», donde se lee y se acepta. Mientras no haya ninguna
   vigente no aparece nada: es la misma pregunta que hace «Mis datos»,
   una sola vez por sesión. Lo monta `AppShell.jsx` (integrador).
   ===================================================================== */
export default function CartelDeAviso({ onIr }) {
  const [faltan, setFaltan] = useState([]);
  const [visto, setVisto] = useState(false);

  useEffect(() => {
    let vivo = true;
    api.get('/legal/vigentes/cuenta_personal')
      .then(async (v) => {
        const vigentes = (v && v.vigentes) || [];
        if (!vivo || vigentes.length === 0) return;
        const mios = await api.get('/cumplimiento/mis-datos').catch(() => ({ aceptaciones: [] }));
        const ya = new Set(((mios && mios.aceptaciones) || []).map((a) => `${a.clave}:${a.version}`));
        if (vivo) setFaltan(vigentes.filter((x) => !ya.has(`${x.clave}:${x.version}`)));
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (visto || faltan.length === 0) return null;
  return (
    <div className="mx-4 mt-3 flex flex-wrap items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
      <ShieldCheck className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>Hay una versión nueva del aviso de privacidad pendiente de aceptar: {faltan.map((f) => `«${f.clave}» ${f.version}`).join(' y ')}.</span>
      <button type="button" onClick={() => onIr?.('cumplimiento-mis-datos')} className="font-semibold underline">Leerla y aceptarla</button>
      <button type="button" onClick={() => setVisto(true)} className="ml-auto text-xs text-amber-800">Ahora no</button>
    </div>
  );
}
